import {Injectable, Injector} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {GtAuthenticationService} from '@app/services/gt-authentication.service';
import {tap} from 'rxjs/operators';

@Injectable()
export class GtRequestInterceptor implements HttpInterceptor {
  protected logoutSent = false;

  constructor(private readonly inj: Injector) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.headers.has('Content-Type')) {
      req = req.clone({
        headers: req.headers.set('Content-Type', 'application/json')
      });
    }
    if (req.headers.has(GtAuthenticationService.SKIP_INTERCEPTOR)) {
      req = req.clone({
        headers: req.headers.delete(GtAuthenticationService.SKIP_INTERCEPTOR)
      });
      console.log('skipped authInterceptor');
      return next.handle(req);
    }
    return next.handle(req).pipe(
      tap(
        (response: any) => {
          if (response.body && response.body.code === 401) {
            console.error('authInterceptor: session expired', response);
            window.localStorage.setItem('request_path', window.location.pathname);
            this.sessionExpired();
          }
        },
        error => {
          console.error(error);
        }
      )
    );
  }

  protected sessionExpired() {
    if (!this.logoutSent) {
      this.logoutSent = true;
      const authService = this.inj.get(GtAuthenticationService);
      authService.doLogout().subscribe();
    }
  }
}
